import { useHitsPerPage } from 'react-instantsearch'

export function VirtualHitsPerPage(props) {
  useHitsPerPage(props)

  return null
}
